import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
@HateoasResource('health-checks', { routeName: 'frontdoorResourceRoute' })
export class HealthCheck extends Resource {
    name: string;
    id: string;
    envZId: string;
    shareToken: any;
    endpoint: string;
    httpVerb: any;
    expectedHttpResponse: number;
    timeoutMilliseconds: number;
    selected: boolean;

}
